<template>
  <div class="flex-1 overflow-auto p-4">
    <woot-button color-scheme="success" class-names="button--fixed-top" icon="add-circle"
      @click="openSchoolClassSectionModal(selectedSchoolAccount, null, null)">
      {{ $t('SCHOOL_CLASS_SECTION.HEADER_BTN_TXT') }}
    </woot-button>
    <div class="flex flex-row gap-4">
      <div class="w-[60%]">
        <div>
          <div class="p-2">
            <label>
              {{ $t('SCHOOL_CLASS_SECTION.LIST.SCHOOL_ACCOUNT_SELECT.LABEL') }}
            </label>
            <multiselect v-model="selectedSchoolAccount" track-by="id" label="school_name"
              :placeholder="$t('SCHOOL_CLASS_SECTION.LIST.SCHOOL_ACCOUNT_SELECT.PLACEHOLDER')" selected-label
              :select-label="$t('SCHOOL_CLASS_SECTION.LIST.SCHOOL_ACCOUNT_SELECT.SELECT_PLACEHOLDER')"
              :deselect-label="$t('SCHOOL_CLASS_SECTION.LIST.SCHOOL_ACCOUNT_SELECT.REMOVE')" :max-height="160"
              :options="schoolAccounts" :allow-empty="false" :option-height="104" :preselect-first="true" />
          </div>

          <p v-if="!uiFlags.isFetching && schoolClassSections && !schoolClassSections.length"
            class="flex h-full items-center flex-col justify-center">
            {{ $t('SCHOOL_CLASS_SECTION.LIST.404') }}
          </p>
          <woot-loading-state v-if="uiFlags.isFetching" :message="$t('SCHOOL_CLASS_SECTION.LOADING')" />

          <table v-if="!uiFlags.isFetching && schoolClassSections && schoolClassSections.length" class="woot-table">
            <thead>
              <th v-for="(thHeader, index) in $t('SCHOOL_CLASS_SECTION.LIST.TABLE_HEADER')" :key="index">
                {{ thHeader }}
              </th>
            </thead>
            <tbody>
              <tr v-for="(schoolClassSection, index) in schoolClassSections" :key="index">
                <td>{{ schoolClassSection && schoolClassSection.schoolClass.school_year }}</td>
                <td>{{ schoolClassSection && schoolClassSection.schoolClass.schooling_type }}</td>
                <td>{{ schoolClassSection && schoolClassSection.schoolClass.school_class }}</td>
                <td>{{ schoolClassSection && schoolClassSection.section }}</td>
                <td class="button-wrapper">
                  <woot-button v-tooltip.top="$t('SCHOOL_CLASS_SECTION.FORM.EDIT')" variant="smooth" size="tiny"
                    color-scheme="secondary" class-names="grey-btn" icon="edit"
                    @click="openSchoolClassSectionModal(selectedSchoolAccount, schoolClassSection.schoolClass, schoolClassSection)" />
                  <woot-button v-tooltip.top="$t('SCHOOL_CLASS_SECTION.FORM.DELETE')" variant="smooth"
                    color-scheme="alert" size="tiny" icon="dismiss-circle" class-names="grey-btn"
                    @click="openDeletePopup(selectedSchoolAccount, schoolClassSection.schoolClass, schoolClassSection)" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="w-[34%]">
        <span v-dompurify-html="$t('SCHOOL_CLASS_SECTION.SIDEBAR_TXT')" />
      </div>
    </div>

    <woot-delete-modal :show.sync="showDeleteConfirmationPopup" :on-close="closeDeletePopup"
      :on-confirm="confirmDeletion" :title="$t('LABEL_MGMT.DELETE.CONFIRM.TITLE')"
      :message="$t('SCHOOL_CLASS_SECTION.DELETE.CONFIRM.MESSAGE')" :message-value="deleteMessage"
      :confirm-text="deleteConfirmText" :reject-text="deleteRejectText" />

    <woot-modal :show.sync="showSchoolClassModal" size="medium" :on-close="hideSchoolClassModal">
      <school-class-section-modal v-if="showSchoolClassModal" :on-close="hideSchoolClassModal"
        :on-submit="submitSchoolClass" :school-account="selectedSchoolAccount" 
        :school-class="selectedSchoolClass" :school-class-section="selectedSchoolClassSection"/>
    </woot-modal>

    <woot-confirm-modal ref="confirmDialog" :title="toggleModalTitle" :description="toggleModalDescription" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import SchoolClassSectionModal from './SchoolClassSectionModal.vue';
import alertMixin from 'shared/mixins/alertMixin';
import timeMixin from 'dashboard/mixins/time';

export default {
  components: {
    SchoolClassSectionModal,
  },
  mixins: [alertMixin, timeMixin],

  data() {
    return {
      loading: {},
      showSchoolClassModal: false,
      showDeleteConfirmationPopup: false,
      selectedSchoolClassSection: {},
      selectedSchoolAccount: null,
      selectedSchoolClass: null,
      toggleModalTitle: this.$t('SCHOOL_CLASS_SECTION.TOGGLE.ACTIVATION_TITLE'),
      toggleModalDescription: this.$t(
        'SCHOOL_CLASS_SECTION.TOGGLE.ACTIVATION_DESCRIPTION'
      ),
    };
  },
  computed: {
    ...mapGetters({
      getAccount: 'accounts/getAccount',
      uiFlags: 'accounts/getUIFlags',
      accountId: 'getCurrentAccountId',
    }),
    schoolAccounts() {
      return this.getAccount(this.accountId)?.school_accounts || []
    },
    schoolClasses() {
      return this.schoolAccounts.find(schoolAccount => schoolAccount.id === this.selectedSchoolAccount?.id)?.school_class_rules || []
    },
    schoolClassSections() {
      const combinedSections = this.schoolClasses.flatMap((schoolClass, index) => 
        schoolClass.school_class_sections.map(section => ({
          ...section,
          schoolClass: schoolClass, // ou schoolClass.id, se preferir referenciar por ID
        }))
      );

      return combinedSections;
    },
    deleteConfirmText() {
      return `${this.$t('SCHOOL_CLASS_SECTION.DELETE.CONFIRM.YES')} ${this.selectedSchoolClassSection?.section
        }`;
    },
    deleteRejectText() {
      return `${this.$t('SCHOOL_CLASS_SECTION.DELETE.CONFIRM.NO')} ${this.selectedSchoolClassSection?.section
        }`;
    },
    deleteMessage() {
      return ` ${this.selectedSchoolClassSection?.section}?`;
    },
  },

  methods: {
    openSchoolClassSectionModal(schoolAccount = null, schoolClass = null, schoolSection = null) {
      this.showSchoolClassModal = true;
      this.selectedSchoolAccount = schoolAccount;
      this.selectedSchoolClass = schoolClass;
      this.selectedSchoolClassSection = schoolSection;
    },
    hideSchoolClassModal() {
      this.showSchoolClassModal = false;
    },
    openDeletePopup(schoolAccount, schoolClass, schoolSection) {
      this.showDeleteConfirmationPopup = true;
      this.selectedSchoolAccount = schoolAccount;
      this.selectedSchoolClass = schoolClass;
      this.selectedSchoolClassSection = schoolSection;
    },
    closeDeletePopup() {
      this.showDeleteConfirmationPopup = false;
    },
    confirmDeletion() {
      this.closeDeletePopup();
      this.deleteSchoolClassSection(this.selectedSchoolAccount, this.selectedSchoolClass, this.selectedSchoolClassSection);
    },

    async deleteSchoolClassSection(schoolAccount, schoolClass, schoolSection) {
      try {
        let payload = {
          school_accounts: [{
            ...schoolAccount,
            school_class_rules: [{...schoolClass, school_class_sections:[{...schoolSection, _destroy: true}]}]
          }]
        };

        await this.$store.dispatch('accounts/update', payload);
        this.showAlert(this.$t('GENERAL_SETTINGS.UPDATE.SUCCESS'));
      } catch (error) {
        this.showAlert(this.$t('GENERAL_SETTINGS.UPDATE.ERROR'));
      }
    },

    async submitSchoolClass(schoolAccount, schoolClassRule, schoolClassSection) {
      try {
        let payload = {
          school_accounts: [{
            ...schoolAccount,
            school_class_rules: [{...schoolClassRule, school_class_sections:[schoolClassSection]}]
          }]
        };

        await this.$store.dispatch('accounts/update', payload);
        this.showAlert(this.$t('GENERAL_SETTINGS.UPDATE.SUCCESS'));
      } catch (error) {
        this.showAlert(this.$t('GENERAL_SETTINGS.UPDATE.ERROR'));
      }
    },
  },
};
</script>
